import React from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonHeader,
  IonContent,
  IonTitle,
  IonIcon,
  IonToolbar,
  IonList,
  IonLabel,
  IonItem,
  IonButtons,
} from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import { Avatar } from 'components/common';
import { useSelector } from 'react-redux';
import { AppSelectors } from 'redux/AppRedux';
import { PaySelectors } from 'redux/PayRedux';
import './ClaimedItems.css';

function ClaimedItemsModal({ open, onClose, ticket }) {
  const venue = useSelector(AppSelectors.selectVenueDetail);
  const ticketItems = useSelector(PaySelectors.selectItems);

  return (
    <IonModal isOpen={open} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={onClose}>
              <IonIcon slot="icon-only" icon={chevronBackOutline} />
            </IonButton>
            <IonTitle>Claimed Items</IonTitle>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <IonItem slot="start">
            <IonLabel>
              <h1>{venue.name}</h1>
              {ticket && ticket.table && (
                <div className="ion-text-uppercase">
                  <span className="text-bold">Table Number</span>:&nbsp;
                  {ticket.table.number}
                </div>
              )}
            </IonLabel>
          </IonItem>
          {ticketItems.map((item) => {
            const allSold = item.remainingQuantity === 0;
            return (
              <IonItem lines="full" key={item.id}>
                <IonLabel color={allSold ? 'medium' : 'primary'}>
                  {item.quantity}&nbsp;&nbsp;
                  {item.name}
                </IonLabel>
                <div
                  className={`avatar-list claimed-users ${
                    allSold ? 'claimed-users--sold' : ''
                  }`}
                >
                  {item.paidUsers.map((u) => (
                    <Avatar
                      key={u.id}
                      firstName={u.firstName}
                      lastName={u.lastName}
                    />
                  ))}
                </div>
              </IonItem>
            );
          })}
        </IonList>
      </IonContent>
    </IonModal>
  );
}

ClaimedItemsModal.propTypes = {
  ticket: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ClaimedItemsModal;
